<script lang="ts">
  import Button from '$components/ui/button.svelte';
  import { storyblokEditable } from '$lib/actions/storyblok-editable';
  import type { FaqTabsStoryblok } from '$types/bloks';

  export let block: FaqTabsStoryblok;
  let selectedTab = 0;
</script>

<div class="container relative mx-auto flex flex-col gap-2" use:storyblokEditable={block}>
  <p class="text-sm text-primary/40 pb-3 w-full">{block.label}</p>
  <div class="flex flex-col gap-4">
    {#if block.tabs}
      {@const selectedTabContent = block?.tabs[selectedTab]?.line}
      <div class="flex gap-2 pb-3 border-b">
        {#each block?.tabs as tab, index}
          <Button
            name={tab.label}
            variant="radio"
            active={index === selectedTab}
            size="sm"
            data-sveltekit-noscroll
            data-sveltekit-preload-data="hover"
            data-sveltekit-preload-code="viewport"
            on:click={() => (selectedTab = index)}
          >
            {tab.label}
          </Button>
        {/each}
      </div>
      {#if selectedTabContent}
        {#each selectedTabContent as line}
          <div class="flex justify-between gap-2">
            <p>{line.left}</p>
            {#if line.right}
              <p>{line.right}</p>
            {/if}
          </div>
        {/each}
      {/if}
    {/if}
  </div>
</div>
